<div class="group-section-edit">
  <div class="form_header_wrap">
    @if (overTitle) {
      <h2 class="title_30">{{ overTitle | translate }}</h2>
    }
    @if (title) {
      <h1 class="title_42">
        {{ title | translate }}
        @if (titleTooltip || messageTooltip) {
          <span class="tooltip_wrap">
            <app-more-info-tooltip
              [class]="'v-align-mid'"
              [titleTooltip]="titleTooltip"
              [message]="messageTooltip"
              [isInnerHTML]="true"
              [contentTemplateRef]="templateRef2"
              >
            </app-more-info-tooltip>
          </span>
        }
      </h1>
    }
    @if (description) {
      <p class="subdesc">{{ description | translate }}</p>
    }
  </div>

  @if (errorsNonField) {
    <div>
      <div class="alert-box mb-1">{{ errorsNonField[0] }}</div>
    </div>
  }

  <ng-container *ngTemplateOutlet="templateRef"></ng-container>
</div>
